import { Box, Flex, Icon, Stack, VStack } from '@chaine/keychaine';
import * as React from 'react';
export const SectionLayout = (props) => {
    const { bottomPadding, children, topPadding } = props;
    const paddingBottom = bottomPadding ? bottomPadding : { base: '16', md: '28' };
    const paddingTop = topPadding ? topPadding : undefined;
    console.log('paddingBottom', bottomPadding);
    return (React.createElement(Box, { as: "section", pb: paddingBottom, pt: paddingTop, position: "relative", overflow: "visible" },
        React.createElement(Box, { mx: "auto" },
            React.createElement(Flex, { align: "flex-start", direction: 'column', justify: "space-between" },
                React.createElement(Box, { display: "flex" }, children)))));
};
export const SectionPrimaryComponentLayout = (props) => {
    const { children } = props;
    return (React.createElement(SectionLayout, { bottomPadding: { base: '14', md: '20', lg: '24' } },
        React.createElement(Box, { zIndex: 10000, w: "100%" }, children)));
};
export const SectionCalloutLayout = (props) => {
    const { leftSection, rightSection, longSection, variant } = props;
    return (React.createElement(SectionLayout, null,
        React.createElement(Box, { zIndex: 10000 },
            React.createElement(Stack, { spacing: { sm: '3', md: '6', lg: '6' } },
                variant === 'long section top' && longSection,
                React.createElement(Stack, { spacing: { sm: '3', md: '6', lg: '6' }, direction: ['column', 'column', 'row'] },
                    React.createElement(Box, { w: { base: undefined, md: '100%' } }, rightSection),
                    React.createElement(Box, { w: { base: undefined, md: '100%' } }, leftSection)),
                variant === 'long section bottom' && longSection))));
};
export const VerticalLine = (props) => {
    const { absolutePosition, height, lineColor, top } = props;
    return (React.createElement(Box, { w: { base: '2.5px', md: '3.5px', lg: '4px' }, height: height, position: absolutePosition ? 'absolute' : undefined, bgGradient: lineColor, borderTopRadius: "full", borderBottomRadius: "full", top: top, left: "50%", transform: absolutePosition ? 'translateX(-50%)' : undefined }));
};
export const SectionTitleLayout = (props) => {
    const { children, displayTopLine, icon, iconBackgroundColor, iconColor, lineColorDown, lineColorUp } = props;
    return (React.createElement(SectionLayout, null,
        React.createElement(VStack, { display: "flex", minW: "12", mr: { base: '3', md: '4', lg: '5' }, align: "center", position: "relative", overflow: "visible" },
            displayTopLine && (React.createElement(VerticalLine, { height: { base: '420px', md: '420px', lg: '278px' }, lineColor: lineColorUp || 'red', absolutePosition: true, top: { base: '-440px', md: '-440px', lg: '-290px' } })),
            React.createElement(Flex, { position: "relative", p: displayTopLine ? 1 : 3, borderRadius: "full", justify: "center", align: "center", _before: {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '50px',
                    height: '50px',
                    borderRadius: 'full',
                    background: iconBackgroundColor,
                    filter: 'blur(8px)'
                } },
                React.createElement(Icon, { as: icon, boxSize: 6, zIndex: 5, color: iconColor })),
            React.createElement(VerticalLine, { height: { base: '300px', md: '350px', lg: '400px' }, lineColor: lineColorDown || 'red', absolutePosition: true, top: "55px" })),
        React.createElement(VStack, { pt: { base: '5px', lg: '4px' }, display: "flex", maxW: "70%", width: "full", align: "flex-start" }, children)));
};
export const SectionDescriptionLayout = (props) => {
    const { lineColor, children } = props;
    return (React.createElement(SectionLayout, { bottomPadding: { base: '24', md: '36', lg: '40' } },
        React.createElement(VStack, { display: "flex", minW: "12", mr: { base: '3', md: '4', lg: '5' }, position: "relative", overflow: "visible" },
            React.createElement(VerticalLine, { absolutePosition: true, height: { base: '660px', md: '800px', lg: '800px' }, lineColor: lineColor || 'linear(to-b, green.500, gray.900)', top: { base: '-100px', md: '-130px', lg: '-130px' } })),
        React.createElement(VStack, { display: "flex", align: "flex-start", overflow: "visible", maxW: "70%" }, children)));
};
export const SectionStatsLayout = (props) => {
    const { children } = props;
    return (React.createElement(SectionLayout, { bottomPadding: { base: '16', md: '20', lg: '20' } },
        React.createElement(Box, { minW: "12", mr: { base: '3', md: '4', lg: '5' }, position: "relative" }),
        React.createElement(VStack, { display: "flex", w: "70%", align: "flex-start", overflow: "visible" }, children)));
};
